<template>
  <div class="wrapper">
    <div class="searchContainer">
      <div class="title">数据筛选</div>
      <div class="searchBar">
        <div class="detailSide">
          输入查询：<el-input
            size="small"
            placeholder="分组名称"
            v-model="searchCondition.reviewGroupName"
            style="width: 240px"
          ></el-input
          >&emsp;输入查询：
          <el-select
            v-model="searchCondition.examinationId"
            size="small"
            placeholder="搜索考试名称"
          >
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.examName"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <!-- <el-input
            size="small"
            placeholder="考试名称"
            v-model="searchCondition.teacherGroupName"
            style="width: 240px"
          ></el-input> -->
        </div>
        <div class="btnSide">
          <el-button type="primary" size="small" @click="getData">
            查询
          </el-button>
          <el-button size="small" @click="pageInit"> 重置 </el-button>
        </div>
      </div>
    </div>
    <div class="tableContainer">
      <div class="actBar">
        <div class="title">数据列表</div>
        <div class="btnSide">
          <el-button size="small" type="primary" @click="editGroup()"
            >添加论文分组</el-button
          >
        </div>
      </div>
      <el-table :data="dataList" border>
        <el-table-column type="selection"></el-table-column>
        <el-table-column label="分组编号" width="40px">
          <template slot-scope="scope">
            {{
              scope.$index +
              1 +
              (searchCondition.jumpPage - 1) * searchCondition.pageSize
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="reviewGroupName"
          label="分组名称"
        ></el-table-column>
        <el-table-column prop="examName" label="考试名称"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column
          prop="teacherGroupName"
          label="教师分组"
        ></el-table-column>
        <el-table-column prop="enable" label="启用">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.enable"
              @change="statusEdit(scope.row)"
              active-text="启用"
              :active-value="1"
              inactive-text="不启用"
              :inactive-value="0"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" style="width: 200px">
          <template slot-scope="scope">
            <el-button @click="editGroup(scope.row)" type="text"
              >编辑</el-button
            >
            <el-button @click="deleteGroup(scope.row)" type="text"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="getData"
        @current-change="getData"
        :current-page.sync="searchCondition.jumpPage"
        :page-sizes="[10, 30, 100]"
        :page-size.sync="searchCondition.pageSize"
        layout="total,sizes, prev, pager, next,jumper"
        :total="searchCondition.total"
      >
      </el-pagination>
    </div>

    <el-dialog
      :title="groupData.id ? '编辑分组' : '添加分组'"
      append-to-body
      :visible.sync="groupData.ifShow"
      width="40%"
    >
      <el-form ref="editForm" :model="groupData" label-width="120px">
        <!-- <el-form-item label="分组编号" prop="groupNo">
          <el-input v-model="groupData.groupNo"></el-input>
        </el-form-item> -->
        <el-form-item label="论文分组名称" prop="reviewGroupName">
          <el-input v-model="groupData.reviewGroupName"></el-input>
        </el-form-item>
        <el-form-item label="考试名称" prop="examinationId">
          <el-select
            v-model="groupData.examinationId"
            size="small"
            placeholder="搜索考试名称"
          >
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.examName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="教师分组" prop="teacherGroupId">
          <el-select
            v-model="groupData.teacherGroupId"
            size="small"
            placeholder="请选择老师分组"
          >
            <el-option
              v-for="item in teacherGroupList"
              :key="item.id"
              :label="item.teacherGroupName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="groupData.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="submitGroup()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTeacherGroupList,
  editThesisGroup,
  getThesisGroupList,
  getTeacherList,
  deleteTeacherGroup,
} from "@/api/paper.js";
import { getExamList } from "@/api/index.js";
export default {
  data() {
    return {
      searchCondition: {
        reviewGroupName: "",
        examinationId: null,
        pageSize: 20,
        jumpPage: 1,
        total: 0,
      },
      groupData: {
        id: 0,
        teacherGroupId: null,
        enable: 0,
        examinationId: null,
        reviewGroupName: "",
        ifShow: false,
      },
      dataList: [],
      examList: [],
      teacherGroupList: [],
      teacherList: [],
    };
  },
  created() {},
  mounted() {
    this.getData();
    this.pageInit();
  },
  methods: {
    editGroup(item) {
      Object.assign(
        this.groupData,
        item ? item : this.$options.data().groupData
      );
      console.log(item);
      this.groupData.member = item && item.member ? item.member.split(",") : [];
      this.groupData.leader = item && item.leader ? item.leader.split(",") : [];
      this.groupData.ifShow = true;
      console.log(this.groupData);
    },
    submitGroup() {
      let postData = {};
      Object.assign(postData, this.groupData);
      postData.member = postData.member.toString();
      postData.leader = postData.leader.toString();
      editThesisGroup(postData).then((data) => {
        this.$message.success(this.groupData.id ? "编辑成功" : "创建成功");
        this.groupData.ifShow = false;
        this.getData();
      });
      // console.log(this.groupData);
    },
    getData() {
      getThesisGroupList(this.searchCondition).then((data) => {
        console.log(data);
        this.dataList = data.records;
        this.searchCondition.total = data.total;
      });
    },
    deleteGroup(item) {
      deleteTeacherGroup({ id: item.id }).then((data) => {
        this.$message.success("删除成功");
        this.getData();
      });
    },
    statusEdit(item) {
      editThesisGroup(item).then(
        (data) => {
          this.$message.success("设置成功");
          this.getData();
        },
        (res) => {
          console.log(res);
          this.getData();
        }
      );
    },
    pageInit() {
      let dataList = this.dataList;
      Object.assign(this.$data, this.$options.data());
      this.dataList = dataList;
      getTeacherList().then((data) => {
        this.teacherList = data;
      });
      getExamList().then((data) => {
        this.examList = data.data;
      });
      getTeacherGroupList({ jumpPage: 1, pageSize: 1000 }).then((data) => {
        this.teacherGroupList = data.records;
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .searchContainer {
    background: #fff;
    border: 1px solid #eee;
    .title {
      padding: 10px;
      font-size: 16px;
      border-bottom: 1px solid #eee;
    }
    .searchBar {
      display: flex;
      justify-content: space-between;
      padding: 15px 10px;
      .detailSide {
        flex: 1;
      }
      .btnSide {
        width: 300px;
        text-align: right;
      }
    }
  }
  .tableContainer {
    margin-top: 20px;
    background: #fff;
    padding: 10px;
    .actBar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 10px;
      .title {
        width: 500px;
        font-size: 16px;
      }
      .btnSide {
        flex: 1;
        text-align: right;
      }
    }
  }
}
</style>
